module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/ig-images/ig-02-0f14b9abb15c22efb87f73a7e69594df.jpg";